import { type ProductDetailsStickSingleFlavor } from "@jti/fe-common";
import { type SingleFlavorSelectorItem } from "@jti/ui/components/SingleFlavorSelector";

import { type ConsumableMatrixItem } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";
import { isConsumableMatrixItem } from "@product-details/type-guards";

export const getSingleFlavorConsumable = (
  consumable: ProductDetailsStickSingleFlavor | ConsumableMatrixItem
): SingleFlavorSelectorItem => {
  const flavorDetails = consumable.product?.flavorDetails?.[0];

  const flavorName = flavorDetails?.name;

  // TODO: Remove check for flavour_label when sticks matrix is removed
  const flavorNameFallback =
    "flavour_label" in consumable && consumable.flavour_label ? consumable.flavour_label : consumable.product?.name;

  return {
    sku: consumable.sku,
    name: flavorName ?? flavorNameFallback,
    description: flavorDetails?.description,
    attributes: flavorDetails?.attributes_custom_?.map(({ id, name, sort_order, value }) => ({
      id: +id,
      name,
      sortOrder: +sort_order,
      value,
    })),
    image: {
      url: consumable.product?.thumbnail?.url,
    },
    flavorFamily: isConsumableMatrixItem(consumable) ? consumable.flavorFamily : undefined,
  };
};
